export default {"src":"/_next/static/media/azure.4ee9d1c4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};